import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { JmkwModule } from '@jeppesen-foreflight/jmkw-core';
import {
  AviationPluginModule,
  JmkwPluginModule,
  TerrainPluginModule
} from '@jeppesen-foreflight/jmkw-extensions';
import { core, aviation } from '../environments/environment';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';

@NgModule({
  declarations: [AppComponent],
  imports: [
    JmkwModule.forRoot(core),
    AviationPluginModule.forRoot(aviation),
    TerrainPluginModule.forRoot(aviation),
    JmkwPluginModule,
    BrowserModule,
    RouterModule.forRoot(appRoutes, { initialNavigation: 'enabledBlocking' })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
